export const XSMALL = 500;
export const SMALL = 576;
export const MEDIUM = 768;
export const LARGE = 992;
export const XLARGE = 1200;



// WEBPACK FOOTER //
// ./library/app/data/breakpoints.js